import {
  buildPath,
  buildTemplatePath,
  Card,
  CrudMode,
  Grid,
  ListContext,
  ListContextValue,
  Page,
  PageRoute,
  Stack,
  useElementBreakpoints,
  useParams,
} from "@compass/core";
import { FilePanel } from "components";
import { DataCenterFile, DataCenterFileViewResource } from "generated/openApi";
import "moment-timezone";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { DataCenterFileInfoTask } from "./DataCenterFileInfoTask";
import { DataCenterFilePageHeader } from "./DataCenterFilePageHeader";
import { DataCenterFileTasks } from "./DataCenterFileTasks/DataCenterFileTasks";


const routeName = "dataCenterFile";

class Params {
  id: number = 0;
  crudMode: CrudMode = "view";
}

export const dataCenterFileViewPageRoute: PageRoute<Params> = {
  handle: "Data Center File",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
};

export const DataCenterFileViewPage = () => {
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();
  const { params } = useParams(routeName, Params);
  const [dataCenterFile, setDataCenterFile] = useState<DataCenterFile>({} as DataCenterFile);
  const [viewResource, setViewResource] = useState<DataCenterFileViewResource>({} as DataCenterFileViewResource);

  useEffect(() => {
    fetch(params.id);

    ApiService.dataCenterFiles.getViewResource(params.id).then((response) => {
      setViewResource(response);
    });
  }, []);

  const fetch = (id: number) => {
    ApiService.dataCenterFiles.get(id).then((response) => {
      setDataCenterFile(response);
    });
  };

  return (
    <Page
      isForm
      header={
        <DataCenterFilePageHeader
          id={params.id}
          canDelete={viewResource.canDelete}
          onDelete={() => {
            navigate("../");
            listContext.loadList?.();
          }}
        />
      }
    >
      <Grid ref={breakpointsRef} container spacing="lg">
        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })}>
          <Card>
            <Stack spacing="lg">
              <FilePanel
                fileName={dataCenterFile?.uploadFile?.fileName}
                fileRef={dataCenterFile?.uploadFile?.fileRef}
                fileSize={dataCenterFile?.uploadFile?.fileSize}
                uploadingData={dataCenterFile?.uploadFile?.uploadingData}
                imagePreviewData={dataCenterFile?.uploadFile?.imagePreviewData}
              />

              <DataCenterFileInfoTask dataCenterFile={dataCenterFile} />
            </Stack>
          </Card>
        </Grid>

        <Grid item xs={setBreakpoints({ md: 8, xs: 12 })}>
          <DataCenterFileTasks dataCenterFileId={params.id} />
        </Grid>
      </Grid>
    </Page>
  );
};
